import { render, staticRenderFns } from "./FakeScreen.vue?vue&type=template&id=16194e30&"
import script from "./FakeScreen.vue?vue&type=script&lang=js&"
export * from "./FakeScreen.vue?vue&type=script&lang=js&"
import style0 from "./FakeScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports